import choVayConst from "constants/choVayConst";
import React from "react";
import Modal from "react-bootstrap/Modal";
import DoiTinhTrangNoApi from "service/doiTinhTrangNoApi";
import { convertToNumber } from "utils/numberExtension";
import handleEscapeKey from "utils/handleEscapeKey";
class DoiTinhTrangNo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isModalOpen: props.show || false, // Trạng thái popup
      debtLevel: 0,
      share: true,
      chovayId: 0,
      chovay: {},
      listTinhTrangNo: [],
    };
    this.toggleModal = this.props.onHide.bind(this);
    // Tạo instance của useEscapeKey và gán vào this.escListener
    this.escListener = handleEscapeKey(this.props.onHide);
  }

  componentDidMount() {
    if (this.state.isModalOpen) this.escListener.addListener();
    //Code lấy tình trạng nợ
    DoiTinhTrangNoApi.getListTinhTrangNo().then((response) => {
      console.log(response, "aaaaaaaaaaaaaaaa11111");
      if (response.status === 200) {
        const dataComboTinhTrang = response.data.map((item) => ({
          value: convertToNumber(item.Code),
          label: item.Name,
        }));
        this.setState({ listTinhTrangNo: dataComboTinhTrang });
      }
    });
  }
  componentWillUnmount() {
    // Gỡ listener khi component unmount
    this.escListener.removeListener();
  }

  toggleModal() {
    // Cập nhật trạng thái popup và thêm/xóa listener khi cần
    this.setState(
      (prevState) => ({ isModalOpen: !prevState.isModalOpen }),
      () => {
        if (this.state.isModalOpen) {
          this.escListener.addListener();
        } else {
          this.escListener.removeListener();
        }
      }
    );
  }

  static getDerivedStateFromProps(props, state) {
    let { data } = props;

    let { chovay } = state;
    if (data !== chovay) {
      return {
        debtLevel: data.DebtLevel,
        chovayId: data.ChoVayId,
        chovay: data,
      };
    } else return state;
  }
  onChangeStatus = (debtLevel) => () => {
    this.setState({ debtLevel });
  };
  doiTinhTrangNo = () => () => {
    let { postDoiTinhTrangNo, onHide, data } = this.props;
    postDoiTinhTrangNo(this.state);
    onHide(data);
  };
  onChangeShare = () => () => {
    let { share } = this.state;
    this.setState({ share: !share });
  };

  onHide = () => {
    this.setState({ isModalOpen: false });
    this.props.onHide();
  };

  render() {
    let props = this.props;
    let { onHide, show, data } = props;
    let { Code, CustomerName } = data;
    let { debtLevel, share, listTinhTrangNo } = this.state;
    return (
      <Modal
        show={show}
        onHide={this.onHide}
        size="modal-dialog modal-lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="modal-new modal fade text-left"
      >
        <Modal.Header>
          <h4 className="modal-title color7-bold" id="myModalLabel16">
            <span className="btn-icon-right">
              <img src="/app-assets/images/icon-doi-tinh-trang-no-v2.png" />
            </span>
            <span style={{ marginLeft: "-20px", marginTop: "10px" }}>
              Đổi tình trạng nợ
            </span>
          </h4>
          <button
            type="button"
            className="close-popup-new"
            onClick={props.onHide}
          >
            <i className="mdi mdi-close"></i>
          </button>
        </Modal.Header>
        <Modal.Body className="">
          <div className="from-tinhtrangno">
            <form className="form tat-toan form-horizontal">
              <div className="form-body">
                <div className="col-md-12">
                  <div style={{ textAlign: "center" }} className="row">
                    {listTinhTrangNo.length > 0 &&
                      listTinhTrangNo.map((item, index) => (
                        <>
                          <div
                            className="col-lg-4"
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <div className="d-inline-block custom-control  mar-bottom-10">
                              <label
                                className="custom-radio"
                                for={"radio" + index}
                                checked
                                style={{
                                  paddingLeft: "10px",
                                  paddingBottom: "10px",
                                }}
                              >
                                <input
                                  type="radio"
                                  name="colorRadio"
                                  id={"radio" + index}
                                  checked={debtLevel === item.value}
                                  onChange={this.onChangeStatus(item.value)}
                                />
                                <span className="radio-mark"></span>
                                {item.label}
                              </label>
                            </div>
                          </div>
                        </>
                      ))}
                  </div>

                  {debtLevel === 50 && (
                    <div>
                      <input
                        type="checkbox"
                        checked={share}
                        autocomplete="off"
                        onChange={this.onChangeShare()}
                        id="chkShare"
                        className="mt-10"
                      />
                      &nbsp;
                      <label htmlFor="chkShare">Chia sẻ thông tin nợ xấu</label>
                    </div>
                  )}
                  {listTinhTrangNo.length > 0 &&
                    listTinhTrangNo.map((item, index) => (
                      <>
                        {debtLevel !== 0 && debtLevel === item.value && (
                          <div className="alert alert-danger mt-1" role="alert">
                            <span className="color-do-bold">
                              Bạn có chắc chắn muốn chuyển hợp đồng{" "}
                              <span className="color-xanh">{Code + " "} </span>{" "}
                              của khách hàng{" "}
                              <span className="color-xanh">{CustomerName}</span>{" "}
                              thành hợp đồng{" "}
                              {debtLevel === item.value ? item.label : null}{" "}
                              không ?{" "}
                            </span>
                          </div>
                        )}
                      </>
                    ))}
                </div>
              </div>
            </form>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-new-main btn-closenew"
            onClick={onHide}
          >
            &nbsp;
            <i class="mdi mdi-close"></i>
            &nbsp; Đóng&nbsp;
          </button>
          <button
            type="button"
            className="btn btn-new-main btn-checknew"
            onClick={this.doiTinhTrangNo()}
          >
            &nbsp;
            <img src="/app-assets/images/icon-doi-tinh-trang-no-trang-v2.png" />
            &nbsp; Đổi tình trạng nợ&nbsp;
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
export default DoiTinhTrangNo;
